import {
  Button,
  Box,
  Typography,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
  Paper,
} from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  Delete as DeleteIcon,
} from '@mui/icons-material';
import { getFileIcon } from '../../utils/fileIcons';

interface FileUploadProps {
  selectedFiles: File[];
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (index: number) => void;
  uploadingFiles: boolean;
  inputId: string;
  title?: string;
}

export const FileUpload: React.FC<FileUploadProps> = ({
  selectedFiles,
  onFileSelect,
  onRemoveFile,
  uploadingFiles,
  inputId,
  title = 'Attachments',
}) => {
  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 1 }}>
        {title}
      </Typography>

      <input
        id={inputId}
        type="file"
        multiple
        accept="image/*,.pdf,.txt,.csv,.json,.doc,.docx"
        onChange={onFileSelect}
        style={{ display: 'none' }}
      />

      <label htmlFor={inputId}>
        <Button
          variant="outlined"
          component="span"
          startIcon={<CloudUploadIcon />}
          disabled={uploadingFiles}
          size="small"
        >
          {uploadingFiles ? 'Uploading...' : 'Choose Files'}
        </Button>
      </label>

      {selectedFiles.length > 0 && (
        <Paper sx={{ mt: 1, p: 1 }} variant="outlined">
          <Typography variant="caption" color="text.secondary">
            Selected files ({selectedFiles.length}):
          </Typography>
          <List dense>
            {selectedFiles.map((file, index) => (
              <ListItem key={index} sx={{ py: 0.5 }}>
                <ListItemIcon sx={{ minWidth: 32 }}>
                  {getFileIcon(file.name, file.type)}
                </ListItemIcon>
                <ListItemText
                  primary={file.name}
                  secondary={`${(file.size / 1024).toFixed(1)} KB`}
                  primaryTypographyProps={{ variant: 'body2' }}
                  secondaryTypographyProps={{ variant: 'caption' }}
                />
                <ListItemSecondaryAction>
                  <IconButton
                    edge="end"
                    size="small"
                    onClick={() => onRemoveFile(index)}
                  >
                    <DeleteIcon fontSize="small" />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))}
          </List>
        </Paper>
      )}

      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
        Supported: Images, PDF, Text, CSV, JSON, Word documents (max 10MB each)
      </Typography>
    </Box>
  );
};
